import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoginComponent} from './components/login/login.component';
import {SignUpComponent} from './components/sign-up/sign-up.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {EmailResponseComponent} from './components/reset-password/email-response/email-response.component';
import {RouterModule} from '@angular/router';
import {AuthComponent} from './auth.component';
import {InputModule} from '../shared/components/input/input.module';
import {ReactiveFormsModule} from '@angular/forms';
import {OptionsListModule} from '../shared/components/options-list/options-list.module';
import {ButtonModule} from '../shared/components/button/button.module';
import {ChoosePharmacyComponent} from './components/choose-pharmacy/choose-pharmacy.component';
import {CheckboxModule} from '../shared/components/checkbox/checkbox.module';
import {DropdownModule} from '../shared/components/dropdown/dropdown.module';
import {BadgeModule} from '../shared/components/badge/badge.module';
import {TabsModule} from '../shared/components/tabs/tabs.module';

const routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'sign-up', component: SignUpComponent,
      },
      {
        path: 'login', component: LoginComponent,
      },
      {
        path: 'select-pharmacy', component: ChoosePharmacyComponent,
      },
      {
        path: 'reset-password', component: ResetPasswordComponent,
      },
      {
        path: 'email', component: EmailResponseComponent,
      },
    ],
  },
];

@NgModule({
  declarations: [
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    EmailResponseComponent,
    AuthComponent,
    ChoosePharmacyComponent
  ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        InputModule,
        ReactiveFormsModule,
        OptionsListModule,
        ButtonModule,
        CheckboxModule,
        DropdownModule,
        BadgeModule,
        TabsModule,
    ]
})
export class AuthModule {
}
